// extracted by mini-css-extract-plugin
export var callCard = "_ki-0";
export var callMessageButton = "_ki-1";
export var helpIcon = "_ki-3";
export var helpIconContainer = "_ki-4";
export var verticalDivider = "_ki-2";